"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSources = exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactProptypeConditionalRequire = _interopRequireDefault(require("react-proptype-conditional-require"));

var _Wrapper = _interopRequireDefault(require("./Wrapper"));

var _ImageContainer = _interopRequireDefault(require("./ImageContainer"));

var _Picture = _interopRequireDefault(require("./Picture"));

var _imageModule = _interopRequireDefault(require("./image.module.less"));

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types -- directive added automatically by Shepherd migration
var getSources = function getSources(props) {
  return (props.sources || []).length ? props.sources : [props];
};

exports.getSources = getSources;

var isSizeDerivable = function isSizeDerivable(props) {
  return !props.expandToContent && props.sources.length <= 1;
};

var Image = function Image(props) {
  var src = props.src,
      srcSet = props.srcSet,
      sizes = props.sizes,
      naturalHeight = props.naturalHeight,
      naturalWidth = props.naturalWidth,
      className = props.className,
      backgroundColor = props.backgroundColor,
      children = props.children,
      expandToContent = props.expandToContent,
      lazy = props.lazy,
      offset = props.offset,
      overflow = props.overflow,
      alt = props.alt,
      imageClassName = props.imageClassName,
      objectFit = props.objectFit,
      objectPosition = props.objectPosition,
      placeholderImage = props.placeholderImage,
      title = props.title,
      caption = props.caption,
      fetchPriority = props.fetchPriority;

  var _React$useState = _react.default.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      isLoaded = _React$useState2[0],
      setIsLoaded = _React$useState2[1];

  var _React$useState3 = _react.default.useState(false),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      error = _React$useState4[0],
      setError = _React$useState4[1];

  _react.default.useEffect(function () {
    // Since we have server side rendering, client side error events could occur
    // prior to React initialization on the client side. Create a custom image component
    // on client side render to check for errors.
    // https://discuss.reactjs.org/t/onerror-for-img-to-hide-images-with-error/2094/12
    var imgLoader = new window.Image();

    imgLoader.onerror = function () {
      setIsLoaded(false);
      setError(true);
    };

    if (src) {
      imgLoader.src = src;
    }

    if (srcSet) {
      imgLoader.srcset = srcSet;
      imgLoader.sizes = sizes;
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps -- directive added automatically by Shepherd migration
  []);

  var onLoad = _react.default.useCallback(function () {
    if (!isLoaded) {
      setIsLoaded(true);
    }
  }, [isLoaded]); // Check for natural height / natural width existence first so we don't do math with an unexpected value


  var aspectRatioPercentage = naturalHeight && naturalWidth ? naturalHeight * 100.0 / naturalWidth : 0;
  var sources = getSources(props);
  var aspectRatio = props.aspectRatio;
  return /*#__PURE__*/_react.default.createElement("figure", {
    className: (0, _classnames.default)(_imageModule.default.figure, className)
  }, /*#__PURE__*/_react.default.createElement(_Wrapper.default, {
    backgroundColor: backgroundColor,
    placeholderImage: placeholderImage // Apply outer aspect ratio classes
    ,
    className: aspectRatio ? (0, _classnames.default)(_imageModule.default['aspect-ratio']) : null,
    aspectRatio: aspectRatio
  }, /*#__PURE__*/_react.default.createElement(_ImageContainer.default, {
    aspectRatioPercentage: aspectRatioPercentage // Apply container aspect ratio
    ,
    hasAspectRatio: !!aspectRatio,
    content: children,
    expandToContent: expandToContent,
    lazy: lazy,
    loaded: isLoaded,
    offset: offset,
    overflow: overflow,
    sources: sources
  }, /*#__PURE__*/_react.default.createElement(_Picture.default, {
    alt: alt,
    className: (0, _classnames.default)(imageClassName, // Apply the correct class on the underlying
    // img element as well if aspectRatio provided
    aspectRatio && _imageModule.default['aspect-ratio-image']),
    error: error,
    expandToContent: expandToContent,
    objectFit: objectFit,
    objectPosition: objectPosition,
    onLoad: onLoad,
    placeholderImage: placeholderImage,
    sources: sources,
    src: src,
    srcSet: srcSet,
    sizes: sizes,
    title: title,
    fetchPriority: fetchPriority
  }))), caption && /*#__PURE__*/_react.default.createElement("figcaption", {
    className: _imageModule.default.figcaption
  }, caption));
};

Image.displayName = 'Image';
Image.propTypes = {
  alt: _propTypes.default.string.isRequired,

  /**
   * This is a prop to restrict the image
   * to the standard NerdWallet-supported
   * aspect ratios. Some common ratios might
   * be '1:1', '5:2', or '13:8'.
   */
  aspectRatio: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  caption: _propTypes.default.node,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  expandToContent: _propTypes.default.bool,
  imageClassName: _propTypes.default.string,
  lazy: _propTypes.default.bool,
  media: _propTypes.default.string,
  // eslint-disable-line react/no-unused-prop-types
  naturalHeight: (0, _reactProptypeConditionalRequire.default)(_propTypes.default.number, isSizeDerivable),
  naturalWidth: (0, _reactProptypeConditionalRequire.default)(_propTypes.default.number, isSizeDerivable),
  objectFit: _propTypes.default.string,
  objectPosition: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  offset: _propTypes.default.number,
  overflow: _propTypes.default.bool,
  placeholderImage: _propTypes.default.string,
  src: _propTypes.default.string.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  sources: _propTypes.default.arrayOf(_propTypes.default.shape({
    media: _propTypes.default.string,
    srcSet: _propTypes.default.string,
    sizes: _propTypes.default.string
  })),
  srcSet: _propTypes.default.string,
  sizes: _propTypes.default.string,
  title: _propTypes.default.string
};
Image.defaultProps = {
  aspectRatio: null,
  lazy: false,
  offset: 100,
  sources: []
};
var _default = Image;
exports.default = _default;